import React from 'react';
import {
  Heading1, Paragraph, LinkStyled, Bold,
} from '../components/typography';
import {
  consentValue,
  optScripts,
  chooseOptInOrOut
} from '../lib/analytics';
import { Container, Row, Col } from '../components/grid';
import FullWidthLayout from '../layout/DefaultLayout/Layouts/FullWidthLayout';
import { CookiesPolitikContent, CookiesPolitikSubTitle, CookiesPolitikTitle, HeadingAbout } from './CookiesPolitik';

export default class Cookies extends React.Component {
  constructor(props) {
    super(props);
    this.resetOpt = this.resetOpt.bind(this);
  }

  componentDidMount() {
    window.updateCookiesPage = () => {
      this.forceUpdate();
    }
  }

  componentWillUnmount() {
    delete window.updateCookiesPage;
  }

  resetOpt() {
    chooseOptInOrOut(null);
    optScripts();
    this.forceUpdate();
    if (window.onConsentReset)
    {
      window.onConsentReset();
    }
  }

  render() {
    const consent = consentValue();
    return (
      <FullWidthLayout>
        <Container mb white>
          <Row>
            <Col xs={12}>
              <Heading1>
                <CookiesPolitikTitle />
              </Heading1>
              <CookiesPolitikSubTitle />
              <CookiesPolitikContent />
              <HeadingAbout>Ændring af dit samtykke</HeadingAbout>
              {consent && (
                <Paragraph>
                  Du <Bold>har {consent.analytics ? '' : 'ikke'}</Bold> givet tilladelse til statistiske cookies og du <Bold>har {consent.marketing ? '' : 'ikke'}</Bold> givet tilladelse til marketing cookies.
                </Paragraph>
              )}
              <Paragraph>
                Du ændrer dit samtykke ved enten at slette cookies fra browseren eller ved at ændre dit oprindelige valg ved at klikke på linket herunder:
              </Paragraph>
              <Paragraph>
                <LinkStyled action onClick={this.resetOpt}>Du ændrer dit samtykke ved at klikke her</LinkStyled><br />
                Husk: Bruger du flere browsere, skal du slette cookies i dem alle.
              </Paragraph>
            </Col>
          </Row>
        </Container>
      </FullWidthLayout>
    );
  }
}
